
  
$(document).ready(function() {
  console.log('announcement');
  console.log($('.announcement').length);
  if ($('.announcement').length > 0) {
    console.log('announcement');
    $('body').addClass('has-announcement');
  }
  $(document).on('click', '.copy-btn', function () {
        const textToCopy = $(this).siblings('.text-to-copy').text();
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                alert('Code copied to clipboard: ' + textToCopy);
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    });
  if($('.announcement').length){
    $('.announcement').parent().addClass('announcement_wrapper');
    $('.site-header').addClass('hasAnnouncement').css('top',$('.announcement').outerHeight(true));
    //$('#NavDrawer').css('top',$('.announcement').outerHeight(true));
    $('#PageContainer').addClass('hasAnnouncementBar');
    
     window.addEventListener('scroll', function () {
      const bar = document.querySelector('.announcement');
      if (window.scrollY > 0) {
        bar.classList.add('hidden');
        $('.site-header').removeClass('hasAnnouncement').css('top',0);
      //  $('#NavDrawer').css('top',0);
      } else {
        bar.classList.remove('hidden');
        $('.site-header').addClass('hasAnnouncement').css('top',$('.announcement').outerHeight(true));
       // $('#NavDrawer').css('top',$('.announcement').outerHeight(true));
      }
    });
  }
  setTimeout(function() {
         console.log('doc ready');
  console.log($('div[option-name="Style"]').length);
  $('div[option-name="Style"] ul li').on('click',function() {
    console.log('style select');
    setTimeout(function() {
        // Your jQuery code here      
     $('div[option-name="Color"] ul li span').click()
     
    }, 500);
  });
    }, 5000);

 
 
    $('.clear-cart').on('click', function() {
   
       $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function() {
                // Successfully cleared the cart, update cart UI here
                $('.cart-items').empty(); // Clear items in the cart UI
                $('.cart-total').text('0.00'); // Update total price if applicable
            },
            error: function() {
                console.error('Failed to clear the cart.');
            }
        });
    });
});
$(document).ready(function() {
  // Check if the popup has been shown in the last 14 days
  // const lastPopupShown = localStorage.getItem('newsletterPopupShown');
  // const twoWeeks = 14 * 24 * 60 * 60 * 1000; // Two weeks in milliseconds
  // const now = new Date().getTime();
  // console.log('popup');
  // If popup has never been shown or it was shown more than 14 days ago
  // if (!lastPopupShown || now - lastPopupShown > twoWeeks) {
  //   console.log('popup in');
  //   // Show the popup after page load
  //   setTimeout(function() {
  //     $.ajax({
  //       url: 'https://sixzerorender.onrender.com/check-customer-orders',
  //       type: 'POST',
  //       contentType: 'application/json',  // Set content type to JSON
  //       data: JSON.stringify({ email: "test@test.com", store: "CA" }),  // Convert data to JSON string
  //       success: function (response) {},
  //     });
  //     $('#newsletter-popup').css('visibility','visible');
  //     $('#newsletter-popup').fadeIn(); 
  //   }, 2000); // 2-second delay

  //   // Set the current time as the last time the popup was shown
  //   localStorage.setItem('newsletterPopupShown', now);
  // }

  // Close popup when "X" is clicked
  $('.close-popup').click(function() {
    $('#newsletter-popup').fadeOut();
    //$('#products-popup').fadeOut();
    $('#products-popup').css('visibility','hidden');
    return false;
  });

  // Optional: Close the popup when the user clicks outside the content area
  $(window).click(function(event) {
    if ($(event.target).is('#newsletter-popup')) {
      $('#newsletter-popup').fadeOut();
    }
  });
  
});
$(document).ready(function () {
  //$('.popup-overlay').css('visibility','visible');
  //$('.popup-overlay').hide();
  $('.popup-footer .btn.checkout').click(function(){
    $('.btn.cart__checkout').click();
  });
  setTimeout(function () {
          //$('.popup-overlay').css('visibility','visible');
           //$('.popup-overlay').hide();
        }, 100); 
  const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('popup') === 'signup') {
      console.log('popup - signup');
$.ajax({
  url: 'https://sixzerorender.onrender.com/check-customer-orders',
  type: 'POST',
  contentType: 'application/json',  // Set content type to JSON
  data: JSON.stringify({ email: "test@test.com", store: "CA" }),  // Convert data to JSON string
  success: function (response) {},
});
      
      $('#newsletter-popup').css('visibility','visible');
        $('#newsletter-popup').fadeIn();
      //$('#products-popup').fadeIn();
    }

  $('#newsletter-form').submit(function (e) {
    e.preventDefault();
   $('#newsletter-form .form-items').hide();
     $('#coupon-message').text("Sending...");
   const email = $('#email-input').val();

$.ajax({
  url: 'https://sixzerorender.onrender.com/check-customer-orders',
  type: 'POST',
  contentType: 'application/json',  // Set content type to JSON
  data: JSON.stringify({ email: email, store: "CA" }),  // Convert data to JSON string
  success: function (response) {
    $('#newsletter-form .form-items').hide();
    if (response.isNewCustomer) {
      //$('#coupon-message').html("Use code <b class='text-to-copy'>WELC12</b> at checkout to receive 12% off.<br/><button class='copy-btn'>Click to Copy Code</button>");
       $('#coupon-message').html("Welcome to the Six Zero family")
    } else {
    $('#coupon-message').html(`
    <p>
        It looks like you've purchased from Six Zero already. Here's a discount code for 15% OFF apparel<br/>
        Code: <span class='text-to-copy'>APP15</span><label>    
            <br/>
            <button class='copy-btn'>Click to Copy Code</button>
        </label>
    </p>
`);

    }
  },
  error: function () {
    $('#coupon-message').text("An error occurred. Please try again.");
  },
});

  });
});

function removeFromCart(event, itemId) {
     event.preventDefault();  // Prevent form submission or default action
     event.stopPropagation(); // Stop event from bubbling up
     event.stopImmediatePropagation(); // Stop other event listeners on the same element
     console.log(itemId);
     console.log('removeFromCart triggered');
      //return false;
     fetch('/cart/change.js', {
         method: 'POST',
         headers: {
             'Content-Type': 'application/json'
         },
         body: JSON.stringify({
             id: itemId,
             quantity: 0
         })
     })
     .then(response => response.json())
     .then(cart => {
         updateCartUI(cart,itemId);
     })
     .catch(error => console.error("Error:", error));
 
     return false; // Prevent further handling
 }
 
// Function to update cart UI dynamically
function updateCartUI(cart, itemId) {
    // Remove the item from the cart UI
    let itemElement = document.querySelector(`.cart_item_${itemId}`);
    if (itemElement) {
        itemElement.remove();
    }
    console.log(cart);
    // Update cart total price
    let cartTotalElement = document.querySelector("div[data-subtotal]");
    if (cartTotalElement) {
        let cartTotal = cart.items_subtotal_price / 100; // Convert cents to dollars
        cartTotalElement.textContent = `$${cartTotal.toFixed(2)}`;
    }

    // Hide cart if empty
    if (cart.item_count === 0) {
        let cartContainer = document.querySelector("#CartDrawer .drawer__scrollable");
        if (cartContainer) {
            //cartContainer.innerHTML = "Your cart is empty.";
        }
      //drawer__footer
      let cartFooter = document.querySelector("#CartDrawer .drawer__footer");
        if (cartContainer) {
            //cartFooter.remove();
            $('.cart-link__bubble').removeClass('cart-link__bubble--visible');
        }
    }
}

$(document).ready(function() {
  setTimeout(function () {
  if ($(window).width() <= 767) {
   
    $('.grid').each(function() {
      var $grid = $(this);
      var $container = $grid.find('> .product-grid-container'); // Only direct children
      var $items = $container.find('.grid__item');
      console.log($container.length);
      if ($items.length === 0) return; // Skip if no items

      $container.remove(); // Remove original container

      for (var i = 0; i < $items.length; i += 2) {
        var $newContainer = $('<div class="product-grid-container"></div>');
        $newContainer.append($items.slice(i, i + 2));
        $grid.append($newContainer);
      }
    });
  }
      $('.grid-overflow-wrapper .grid, .grid .product-grid-container').each(function() {
        var $grid = $(this);
        var addClass = false;
    
        $grid.find('ul.swatch-view').each(function() {
          if ($(this).find('li').length > 2) {
            addClass = true;
            return false; // Exit loop early since we found one
          }
        });
    
        if (addClass) {
          $grid.find('ul.swatch-view').addClass('extra-height');
        }
      });
  }, 2000); 
 
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header-item [data-disclosure-form]').forEach(function (el) {
    new theme.Disclosure(el);
  });
});
document.querySelectorAll(' [data-disclosure-option]').forEach(option => {
  option.addEventListener('click', function(e) {
    
    const redirectUrl = e.currentTarget.getAttribute('data-redirect-url');
    if (redirectUrl) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Stop other handlers (like Shopify’s Disclosure logic)
      console.log(redirectUrl);
      window.location.href = redirectUrl;
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  // Check if the fieldset with name="Texture" exists
  const textureFieldset = document.querySelector('fieldset.variant-input-wrap[name="T"]');
  if (textureFieldset) {
    // Hide the parent div
    const parentDiv = textureFieldset.closest('div');
    if (parentDiv) {
      parentDiv.style.display = "none";
    }
  }
});
